export const reservasModals = {
  roomChange: {
    close: "Cerrar",
    titleAssign: "Asignar habitación",
    titleChange: "Cambiar habitación",
    stopSoldNote:
      "Este tipo está cerrado para venta en estas fechas (stop-sell), pero puedes reorganizar las habitaciones igualmente: mover o asignar no vuelve a abrir la venta.",
    labelAssign: "Habitación a asignar",
    labelNew: "Nueva habitación",
    selectPlaceholder: "Selecciona una habitación…",
    swapWith: "Intercambiar con {names}",
    swapWithType: "Intercambiar con {names} (pasa a {type})",
    swapTypeWarning: "Al intercambiar, {names} pasa a {type}, que no es el tipo que reservó.",
    swapGroup:
      "Intercambio en grupo: {name} y {also} pasan a esa habitación, y {incoming} vienen a la tuya. Todo en una sola operación.",
    swapSingle:
      "Esa habitación está ocupada por {names}. Al guardar se {action}: tu reserva pasa a esa habitación y la(s) otra(s) pasan a la tuya.",
    swapWord: "intercambiarán",
    emptyNote:
      "Ninguna habitación está libre el rango completo. Usa el botón {action} del carril «Por organizar» para reacomodar las reservas automáticamente.",
    organizeWord: "Organizar",
    sameTypeGroup: "Mismo tipo · {name}",
    otherTypeGroup: "Otro tipo · {name}",
    typeChangeNote:
      "La reserva pasará a {type}. Se actualiza su ficha, se recalcula la disponibilidad de los dos tipos y se avisa a los canales.",
    selectRoomError: "Debes seleccionar una habitación",
    cancel: "Cancelar",
    confirmSwap: "Intercambiar",
    confirmAssign: "Asignar",
    confirmSave: "Guardar cambio",
  },
  outOfOrder: {
    titleMaintenance: "Mantenimiento de habitación",
    titleActions: "Acciones del tipo de habitación",
    scopeLabel: "Ámbito",
    scopeUnit: "Tipo (todas)",
    scopeInstance: "Esta habitación",
    actionLabel: "Acción",
    actionOoo: "Fuera de servicio (mantenimiento)",
    actionOpen: "Reabrir en el rango",
    quantityLabel: "Cantidad de habitaciones",
    maxPerDay: "Máximo {max} por día.",
    dateRangeLabel: "Rango de fechas",
    from: "Desde",
    to: "Hasta",
    cancel: "Cancelar",
    apply: "Aplicar",
  },
  closeDay: {
    title: "Cambiar disponibilidad",
    syncing: "Sincronizando disponibilidad...",
    roomTypeLabel: "Tipo de habitación",
    roomTypePlaceholder: "Selecciona una habitación",
    startDate: "Fecha inicio",
    endDate: "Fecha fin",
    maxAvailable: "Máximo: {count} disponibles",
    cancel: "Cancelar",
    apply: "Aplicar cambio",
  },
  confirm: {
    defaultTitle: "¿Confirmar?",
    confirm: "Confirmar",
    cancel: "Cancelar",
  },
  updateAlert: {
    title: "Actualizar habitación",
    sectionTitle: "Información de la habitación",
    nameLabel: "Nombre o número de habitación",
    keyLabel: "LLave de acceso",
    cancel: "Cancelar",
    submit: "Actualizar Habitación",
    nameRequired: "El nombre o número de habitación es requerido",
  },
};
